import en from './en'
import ptBR from './pt-br'
import es from './es'

export default {
  'en': en,
  'pt-BR': ptBR,
  'es': es
}




// WEBPACK FOOTER //
// ./src/language/locales.js